module.exports = __webpack_public_path__ + "static/media/94140019-AYQ0wSgs.f0b417a4.JPG";